// useChatRender - 后台薄包装层
//
// 🔁 2026-10-27：拆分方式
//   - 纯函数（currentTime / getToolDisplayName / parseWebSearchResults / ...）
//     → @huyu/core/ai，三端共享，本文件直接 `export *` 转出，组件 import 路径不变
//   - renderMessageHtml / useChatRender（依赖运行时 Markdown 渲染器与路由）
//     → @huyu/core/vue，本文件包装并注册后台适配器
import {
  useChatRender as useCoreChatRender,
  renderMessageHtml
} from '@huyu/core/vue'
import { ensureAiRuntime } from './aiRuntime'

// 纯函数全量转出（保持组件 `from '@/.../useChatRender'` 的既有 import 不变）
export * from '@huyu/core/ai'

export { renderMessageHtml }

export function useChatRender(options = {}) {
  ensureAiRuntime()
  return useCoreChatRender(options)
}
